import { jsx as i } from "react/jsx-runtime";
import { cn as m } from "@tameeni/shared-logic";
import { useState as c, useEffect as f } from "react";
function d({
  className: a,
  src: e,
  ...o
}) {
  const [s, n] = c("");
  return f(() => {
    e instanceof Promise && e.then((t) => n(t.default)).catch((t) => console.log({ e: t }));
  }, [e]), s ? /* @__PURE__ */ i(
    "img",
    {
      src: s,
      className: m("object-scale-down size-6", a),
      ...o,
      alt: o.alt || ""
    }
  ) : /* @__PURE__ */ i(
    "div",
    {
      className: m("animate-pulse rounded bg-slate-200/50 size-6", a)
    }
  );
}
export {
  d as default
};
//# sourceMappingURL=lazy-image.js.map
